import { SafeError, SafePromise } from '@benzinga/safe-await';
import { OnboardingRestful } from './restful';
import { Session } from '@benzinga/session';
import { ListenableSubscribable } from '@benzinga/subscribable';
import {
  IterableWorkflowRequest,
  IterableWorkflowResponse,
  MarketInterestResponse,
  OnboardingDataResponse,
  OnboardingUserQuestionsPayload,
  PortfolioResponse,
} from './entities';

interface OnboardingEvent {
  error: SafeError;
  type: 'onBoarding_event';
}

export class OnboardingRequest extends ListenableSubscribable<OnboardingEvent> {
  private restful: OnboardingRestful;

  constructor(session: Session) {
    super();
    this.restful = new OnboardingRestful(session);
  }

  public setMarketInterest = async (
    interest: string,
    userHubspotId: string | undefined,
  ): SafePromise<MarketInterestResponse> => {
    const res = await this.restful.setMarketInterest(interest, userHubspotId);
    return res;
  };

  public getPortfolioAccessToken = async (): SafePromise<PortfolioResponse> => {
    const res = await this.restful.getPortfolioAccessToken();
    return res;
  };

  public getOnboardingData = async (): SafePromise<OnboardingDataResponse> => {
    return await this.restful.getOnboardingData();
  };

  public submitOnboardingUserQuestions = async (body: OnboardingUserQuestionsPayload): SafePromise<unknown> => {
    return await this.restful.submitOnboardingUserQuestions(body);
  };

  public triggerIterableWorkflow = async (body: IterableWorkflowRequest): SafePromise<IterableWorkflowResponse> => {
    return await this.restful.triggerIterableWorkflow(body);
  };
}
